const Config = {
    serverUrl: "https://stormy-castle-43023.herokuapp.com"
    // serverUrl: "http://localhost:5000"
}

export default Config;


// git subtree push --prefix backend heroku master